import { useTranslation } from 'react-i18next';

// Import components
import { Loader, Tooltip } from 'components/elements';
import { Button } from 'components/elements/atoms/Button/Button';

// Import styles
import { Container, MessageWrapper, Message, ButtonsWrapper, StyledIconInfo, StyledButton } from './styles';

// Import types
import type { LastPaymentsRedirectUrl } from 'types/api/payments';

// Import hooks
import { useLastTransaction } from 'components/views/offer_configurator/hooks';

type Props = {
	payment: LastPaymentsRedirectUrl;
	type: 'packet' | 'product';
};

export const PaymentPendingBar = ({ type, payment }: Props) => {
	const { t } = useTranslation('transaction');
	const { title, isFailed, isLoading, onCancel, onRetry } = useLastTransaction(payment, type);

	return (
		<>
			{isLoading && <Loader />}

			<Container data-aos="fade-down">
				<MessageWrapper>
					<Message>{t(`payment_pending_${type}_${payment.status}`, { title })}</Message>
					{!isFailed && (
						<Tooltip i18nKey="payment_failed_tooltip" namespace="transaction" modifiers="secondary">
							<StyledIconInfo />
						</Tooltip>
					)}
				</MessageWrapper>
				<ButtonsWrapper>
					{payment.redirect_url && (
						<StyledButton onClick={onRetry} disabled={isLoading} isLoading={isLoading} variant="primary" modifiers={['outlined']}>
							{t(isFailed ? 'button_retry_payment' : 'button_finish_payment')}
						</StyledButton>
					)}

					{payment.payment_id && (
						<Button onClick={onCancel.bind(null, undefined)} disabled={isLoading} variant="primary" modifiers={'text'}>
							{t('button_cancel')}
						</Button>
					)}
				</ButtonsWrapper>
			</Container>
		</>
	);
};
